import { Alert, Typography } from "@mui/material";
import { StyledContainer, StyledVideoContainer } from "./Generating.styles";

const Generating = () => (
  <StyledContainer>
    <Alert severity="info">
      AI
      是輔助工具，不能取代教師的專業判斷。請謹慎審核每一道生成的題目，確保其準確性
    </Alert>
    <StyledVideoContainer>
      <video autoPlay loop muted playsInline width="100%">
        <source src="/generationPage/loading.mp4" type="video/mp4" />
      </video>
      <Typography variant="h4" color="primary">
        AI 正在思考中，請稍候...
      </Typography>
    </StyledVideoContainer>
  </StyledContainer>
);

export default Generating;
